/** Una fila del editor, como texto: se convierte a numeros al calcular. */
export interface FilaPartida {
  descripcion: string
  costo: string
  iva: '0' | '0.15'
  margen: string
}

// Lo que la lista Marriott no trae y casi toda industrial necesita. Solo la
// descripcion: el costo lo pone quien tiene la cotizacion del proveedor.
const SUGERIDAS: { descripcion: string; iva: FilaPartida['iva'] }[] = [
  { descripcion: 'Transformador trifásico', iva: '0.15' },
  { descripcion: 'Celdas de media tensión', iva: '0.15' },
  { descripcion: 'Instalación y montaje', iva: '0.15' },
  { descripcion: 'Obra civil', iva: '0.15' },
  { descripcion: 'Trámite ARCONEL / CNEL', iva: '0.15' },
]

interface Props {
  filas: FilaPartida[]
  alCambiar: (filas: FilaPartida[]) => void
  /** Fraccion, para el placeholder del margen. */
  margenPorDefecto?: number
}

export function PartidasManuales({ filas, alCambiar, margenPorDefecto }: Props) {
  const cambiar = (indice: number, cambio: Partial<FilaPartida>) =>
    alCambiar(filas.map((f, i) => (i === indice ? { ...f, ...cambio } : f)))
  const anadir = (descripcion = '', iva: FilaPartida['iva'] = '0.15') =>
    alCambiar([...filas, { descripcion, costo: '', iva, margen: '' }])
  const margen = margenPorDefecto === undefined ? '' : `${Math.round(margenPorDefecto * 100)} por defecto`

  return (
    <div className="partidas">
      <div className="partidas-cabecera">
        <h3>Partidas manuales</h3>
        <small className="ayuda">Lo que no está en la lista Marriott: media tensión, mano de obra, trámites. Costo para SunSmart, sin IVA.</small>
      </div>
      {filas.length > 0 && (
        <div className="tabla-envoltura">
          <table className="tabla compacta">
            <thead>
              <tr>
                <th>Descripción</th>
                <th className="num">Costo (USD)</th>
                <th>IVA</th>
                <th className="num">Margen (%)</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {filas.map((f, i) => (
                <tr key={i} className="sin-clic">
                  <td>
                    <input value={f.descripcion} onChange={(e) => cambiar(i, { descripcion: e.target.value })} maxLength={160} aria-label="Descripción" />
                  </td>
                  <td>
                    <input value={f.costo} onChange={(e) => cambiar(i, { costo: e.target.value })} inputMode="decimal" aria-label="Costo" />
                  </td>
                  <td>
                    <select value={f.iva} onChange={(e) => cambiar(i, { iva: e.target.value as FilaPartida['iva'] })} aria-label="IVA">
                      <option value="0.15">15 %</option>
                      <option value="0">0 %</option>
                    </select>
                  </td>
                  <td>
                    <input value={f.margen} onChange={(e) => cambiar(i, { margen: e.target.value })} inputMode="decimal" placeholder={margen} aria-label="Margen" />
                  </td>
                  <td>
                    <button type="button" className="enlace" onClick={() => alCambiar(filas.filter((_, j) => j !== i))}>
                      Quitar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="filtros">
        {SUGERIDAS.filter((s) => !filas.some((f) => f.descripcion === s.descripcion)).map((s) => (
          <button type="button" key={s.descripcion} className="chip" onClick={() => anadir(s.descripcion, s.iva)}>
            + {s.descripcion}
          </button>
        ))}
        <button type="button" className="chip" onClick={() => anadir()}>
          + Otra partida
        </button>
      </div>
    </div>
  )
}
